import { getContext } from '@fiverr-private/fiverr_context';

/**
 * Returns whether in business experience.
 *
 * @returns {boolean}
 */
export const inBusinessExperience = () => {
    const { experience } = getContext();

    return Boolean(experience && experience.isBusiness);
};
